module.exports = __webpack_public_path__ + "img/arrow-down.a93bb485.svg";